import axios from 'axios';
import thunk from 'redux-thunk';
import _map from 'lodash/map';
import _find from 'lodash/find';
import createPublicApi from './public-api';
import {GROUP_SLUG_PATTERN, GROUPS_API_URL, PUB_SUB_CHANNEL_MODAL} from './constants';
import {initHeader} from './group-header-core';
import configureStore from './state/configure-store';
import groupPageRootReducer from './state/group-page-root-reducer';
import {MinimalPubSub} from './lib/minimal-pub-sub';
import {siteModalsBootstrap, startProxyActionAuth} from './lib/site-modals/site-modal';
import {setCurrentUser, setPrivacyStatus} from './state/actions/current-user-actions';
import {MODAL_LISTENER_NAME} from './lib/site-modals/constants';
const loadTranslations = require('groups-common/src/lib/platform-translations-getter');

let currentGroup = {};
let publicApi;
let router;
let groupPageStore;
let headerTranslations;
let wixApi;

function getGroupsApiAxiosInstanceClientFactory(instance, user) {
  // TODO: use fetch that is in the worker by default
  let lastInstance = instance;
  user.onLogin(next => {
    setTimeout(() => {
      lastInstance = user.currentUser;
      console.log(next, user.currentUser);
    });
  });

  return () => axios.create({
    baseURL: GROUPS_API_URL,
    timeout: 10000,
    headers: {
      Authorization: lastInstance,
    },
  });
}

function createGroupPageStore({instance, user, currentGroup, publicPubSub}) {
  const getGroupsApi = getGroupsApiAxiosInstanceClientFactory(instance, user);
  const currentUser = user.currentUser;

  const store = configureStore(
    {currentGroup, currentUser},
    [thunk.withExtraArgument({getGroupsApi}), ...siteModalsBootstrap.middleware(publicPubSub)],
    groupPageRootReducer,
  );

  const getPrivacyStatus = () => {
    store.dispatch(startProxyActionAuth({type: 'auth/PRIVACY_STATUS'}))
      .then(status => store.dispatch(setPrivacyStatus(status)));
  };

  getPrivacyStatus();

  user.onLogin(nextUser => {
    publicPubSub.removeListener(PUB_SUB_CHANNEL_MODAL, MODAL_LISTENER_NAME); // since iframes are reloaded after login, we must remove root modal listener by hand
    store.dispatch(setCurrentUser(nextUser));
    getPrivacyStatus();
  });
  return store;
}

function renderMenus(config) {
  config.$w('@groups_menu').forEach(menu => {
    if (!menu.isVisible) {
      return;
    }

    const originalItems = _map(menu.items, menuItem => {
      const parts = menuItem.link.split('/');
      parts[2] = GROUP_SLUG_PATTERN;
      menuItem.link = parts.join('/');
      return menuItem;
    });

    const visibleMenuItems = _map(originalItems, menuItem => {
      const routeConfig = _find(router.config.patterns, (_routeConfig, pattern) => {
        return `/${router.prefix}${pattern}` === menuItem.link;
      });
      const appDefinitionId = routeConfig.appData.appDefinitionId;
      const isVisible = currentGroup.config[appDefinitionId];
      return Object.assign({}, menuItem, {
        visibleOnDesktop: isVisible,
        visibleOnMobile: isVisible,
      });
    });

    menu.items = _map(visibleMenuItems, menuItem => {
      menuItem.link = menuItem.link.replace(GROUP_SLUG_PATTERN, currentGroup.slug);
      return menuItem;
    });
  });
}

// function replaceUrlParts(url) {
//   return url
//     .replace(GROUP_SLUG_PATTERN, currentGroup.slug)
//     .replace(encodeURI(GROUP_SLUG_PATTERN), currentGroup.slug)
//     .replace(currentGroup.groupId, currentGroup.slug);
// }

module.exports = {
  initAppForPage: (...args) => {
    //console.log('[viewer-app-module]', 'initAppForPage()', args);
    const {appRouters, routerReturnedData, instance} = args[0];
    wixApi = args[2];
    const {user, window, location} = wixApi;
    const publicPubSub = new MinimalPubSub();
    publicPubSub.onAny((...args) => console.log('[groups-platform-pubsub-debug]', ...args));
    publicApi = createPublicApi({appRouters, routerReturnedData, _self: self, location, eventEmitter: publicPubSub});

    if (!routerReturnedData) {
      return Promise.resolve();
    }

    router = appRouters[0];
    router.config = JSON.parse(router.config);

    user.onLogin(() => location.to(location.url)); // HACK because there is something wrong with instance after login, it's no good for auth
    return loadTranslations('header-app', window.locale).then(({t}) => {
      headerTranslations = t;
      currentGroup = routerReturnedData.group;
      groupPageStore = createGroupPageStore({instance, user, currentGroup, publicPubSub});
    });
  },

  createControllers: controllerConfigs => {
    console.log('[viewer-app-module]', 'createControllers()', controllerConfigs);
    return controllerConfigs.map(config => {
      const pageReady = () => {
        // if (wixApi.window.viewMode === 'Site') {
        //   const wixLocation = wixApi.location;
        //   const query = wixLocation.query;
        //   const queryParams = `${Object.keys(query).length > 0
        //     ? '?' + Object.keys(query).map(k => `${k}=${query[k]}`).join('&')
        //     : ''}`;
        //   wixLocation.to(
        //     replaceUrlParts(`/${wixLocation.prefix}/${wixLocation.path.join('/')}${queryParams}`),
        //   );
        // }
        renderMenus(config);
        initHeader(config, groupPageStore, headerTranslations, wixApi);
      };

      return {
        pageReady,
        exports: {},
      };
    });
  },

  exports: {
    get getViewedUser() {
      return publicApi.getViewedUser;
    },
    get navigateToSection() {
      return publicApi.navigateToSection;
    },
    get getSectionUrl() {
      return publicApi.getSectionUrl;
    },
    get navigateToGroup() {
      return publicApi.navigateToGroup;
    },
    get getMenuRoutes() {
      return publicApi.getMenuRoutes;
    },
    get getCurrentGroupLink() {
      return publicApi.getCurrentGroupLink;
    },
    get registerEventListener() {
      return publicApi.registerEventListener;
    },
    get publishEvent() {
      return publicApi.publishEvent;
    },
  },
};
